import _createClass from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _classCallCheck from "/Users/hart/dev/applications/personal-website/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
export var ParticlesInteractorBase = /*#__PURE__*/_createClass(function ParticlesInteractorBase(container) {
  _classCallCheck(this, ParticlesInteractorBase);

  this.container = container;
  this.type = 1;
});